<div class="mb-3">
  <label *ngIf="label" class="form-label" [attr.for]="inputId || null">
    {{ label }}
    <span *ngIf="required" class="text-danger ms-1">*</span>
  </label>

  <div class="position-relative">
    <!-- Prefix icon -->
    <span *ngIf="prefixIcon" class="is-password-field__icon">
      <i [class]="'bx ' + prefixIcon + ' text-muted'"></i>
    </span>

    <input
      [id]="inputId"
      [type]="inputType"
      class="form-control is-password-field__input"
      [class.is-invalid]="hasError"
      [class.ps-5]="!!prefixIcon"
      [placeholder]="placeholder"
      [disabled]="isDisabled"
      [value]="value"
      (input)="handleInput($event)"
      (blur)="handleBlur()"
    >

    <!-- Toggle visibility -->
    <button
      type="button"
      class="btn btn-link is-password-field__toggle"
      (click)="toggleVisibility()"
      tabindex="-1"
      [attr.aria-label]="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
    >
      <i [class]="'bx ' + (showPassword ? 'bx-hide' : 'bx-show')"></i>
    </button>
  </div>

  <small *ngIf="helpText && !hasError" class="form-text text-muted">{{ helpText }}</small>

  <is-form-error *ngIf="control" [control]="control"></is-form-error>
</div>
